/**
 * Versão nova publicada enquanto a aba estava aberta: os arquivos antigos (com
 * hash) somem do GitHub Pages e um `import()` sob demanda falha. Avisamos e
 * oferecemos recarregar — o estado da tela volta pelo link (query string).
 */
import { RefreshCw } from 'lucide-react';
import { useUiStore } from '../state/ui';
import { writeUrlNow } from '../state/urlSync';
import { Button, Dialog } from './primitives';

/** Liga o aviso quando o Vite não consegue baixar um pedaço do app. */
export function installStaleBuildDetection(): void {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    useUiStore.getState().set({ updateAvailable: true });
  });
}

export function reloadApp(): void {
  writeUrlNow();
  window.location.reload();
}

export function UpdateNotice() {
  const open = useUiStore((s) => s.updateAvailable);
  const set = useUiStore((s) => s.set);
  return (
    <Dialog
      open={open}
      onClose={() => set({ updateAvailable: false })}
      title="Nova versão disponível"
      footer={
        <Button variant="primary" icon={RefreshCw} onClick={reloadApp}>
          Recarregar
        </Button>
      }
    >
      <p className="leading-relaxed">
        O AmaView foi atualizado enquanto esta página estava aberta, e uma parte dele não pôde ser carregada. Recarregue
        a página para usar a versão nova — as camadas e o período escolhidos são mantidos.
      </p>
    </Dialog>
  );
}
